import { useQuery } from 'react-query';
import { http } from '../../http';

export async function fetchMutationForm(commercialLabel: string, mutationInfo: MutationInfo) {
  const response = await http({
    url: `/api/mutations/application-forms/${commercialLabel}/${mutationInfo.type}`,
    method: 'GET',
    responseType: 'blob',
    headers: { Accept: 'application/octect-stream' },
  });

  const contentDisposition = response.headers['content-disposition'] ?? '';
  const filename = contentDisposition.match(/filename="(.+)"/i)?.[1] ?? 'formulier.pdf';

  const url = window.URL.createObjectURL(response.data);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  link.click();
  window.URL.revokeObjectURL(url);
}

export async function uploadMutationForm(
  loanNumber: string,
  mutation: MutationInfo,
  uploadedFile: File,
  commercialLabel: string
) {
  const formData = new FormData();
  formData.append(
    'json',
    JSON.stringify({ loanNumber: Number(loanNumber), mutationType: mutation.type, commercialLabel })
  );
  formData.append('uploadedFile', uploadedFile);

  const response = await http({
    url: '/api/mutations',
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data: formData,
  });

  return response;
}

export type LoanInfo = {
  moneylender: string;
  mutations: MutationInfo[];
};

type MutationType =
  | 'Raise'
  | 'Conversion'
  | 'ConversionWithRaise'
  | 'DismissalJointLiability'
  | 'Transfer'
  | 'CustomApplication'
  | 'CollateralValue';

export type MutationInfo = {
  type: MutationType;
  applicationForm: string;
  customFormUrl?: string;
};

async function getMutationInfo(loanNumber: number, commercialLabel: string): Promise<LoanInfo> {
  const response = await http(`/api/mutations/info/${commercialLabel}/${loanNumber}`);
  return response.data;
}

export function useQueryMutationInfo(loanNumber?: number, commercialLabel?: string) {
  return useQuery(['mutations/info', loanNumber], () => {
    return loanNumber && commercialLabel ? getMutationInfo(loanNumber, commercialLabel) : undefined;
  });
}
